import React from 'react';
import { Divider, Input, Button, Icon } from 'react-native-elements';
import './contact-form.css';
import MessageCard from './MessageCard';

interface InputProps {
  title: string;
  required?: boolean;
}

const FormItem: React.FC<InputProps> = ({ title, required }) => (
  <div className="form-item">
    <p>{title}</p>
    <input required={required} />
  </div>
);

const ContactForm: React.FC = () => {
  return (
    <div id="contact-section">
      {/* Left Side*/}
      <div className="left-form">
        <span className="title">Send Us A Message</span>
        <div>
          <div className="body-divider" />
          <div className="body">
            <p>
              We are here to answer any questions you may have about Zonetail,
              including careers. Reach out to us and we'll respond as soon as we
              can. <a href="mailto:appz@zonetail.com">appz@zonetail.com</a>
            </p>
          </div>
        </div>
        <div className="divider">
          <Divider />
        </div>
        {/* <form className="contact-form">
          <FormItem title="Your Name (required)" required />
          <FormItem title="Your Email (required)" required />
          <div className="form-item">
            <p>Your Message</p>
            <textarea />
          </div>
          <button className="submit-button" type="submit">
            SEND MESSAGE
          </button>
        </form> */}
      </div>
      {/* Right Side*/}
      <div className="right-form">
        <MessageCard
          country="U.S."
          company="Zonetail Inc."
          address="420 S Cataract Ave"
          location="San Dimas, CA"
          postalCode="91773, USA"
        />
        <div className="divider">
          <Divider />
        </div>
        <MessageCard
          country="Canada"
          company="Zonetail Inc."
          address="70 University Ave, Suite 1460"
          location="Toronto, ON"
          postalCode="M5J 2M4"
        />
        <div className="divider">
          <Divider />
        </div>
        <div className="email">
          <Icon
            tvParallaxProperties={null}
            name="email"
            raised
            reverse
            color="rgb(236, 28, 36)"
            underlayColor="white"
            size={20}
            onPress={() => console.log('pressed')}
          />

          <p className="email-text">
            <a href="mailto:appz@zonetail.com">appz@zonetail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
